export default function NotFound() {
  return (
    <>
      <h1>Not Found Page</h1>
    </>
  );
}
